import { useEffect } from 'react';

const usePageTitle = (title) => {
    useEffect(() => {
        if (!title) return undefined;
        const previous = document.title;
        document.title = `${title} | ICE SSO`;
        return () => {
            document.title = previous;
        };
    }, [title]);
};

export default usePageTitle;
